import styled, { css } from 'styled-components';
import Typography from 'ggApp/shared/components/typography';
import { LayoutComponent_Grid_Col as Col } from 'ggApp/modules/layout';

export const RowList = styled.div`
    margin-bottom: 60px;
    ${props => props.theme.superQuery.all.and.maxWidth.tabletMax.css`
        margin-bottom: 30px;
    `};
`;

export const StyledColumn = styled.div`
    ${(props) => css(props.theme.typography.Paragraph)};
    display: inline-flex;
    ${({ bold }) => bold
        && css`
            font-weight: bold;
        `}
`;

export const StyledRow = styled.div`
    display: flex;
    justify-content: space-between;
    padding: ${({ theme }) => theme.spacers.L};
    border-bottom: 2px solid ${({ theme }) => theme.colors['Level 1']};
    color: ${({ theme }) => theme.colors.Foreground};

    &:last-child {
        border-bottom: none;
        padding-bottom: 0;
    }

    ${props => props.theme.superQuery.all.and.maxWidth.tabletMax.css`
        padding-left: 0px;
    `};
`;

export const TaxNote = styled(Typography).attrs({
    tag: 'h4',
})`
    margin-left: 5px;
    display: inline;
    align-self: center;
`;

export const SummaryNote = styled.div`
    padding: ${({ theme }) => theme.spacers.L};
    clear: right;
    ${props => props.theme.superQuery.all.and.maxWidth.tabletMin.css`
        display: none;
    `};
`;

export const ButtonWrapper = styled.div`
    float: right;
    padding-right: ${({ theme }) => theme.spacers.L};
    margin-bottom: 19px;
`;

export const OrderTableSummaryWrapper = styled.div`
    ${props => props.theme.superQuery.all.and.maxWidth.tabletMax.css`
        padding: 0 16px;
    `};
`;

export const SummaryColumn = styled(Col)`
    border-left: 2px solid ${({ theme }) => theme.colors['Level 1']};
    align-self: stretch;
    ${props => props.theme.superQuery.all.and.maxWidth.tabletMax.css`
        border-left: none;
    `};
`;
